export type GuideData = {
  id: number;
  heading: string;
  creationDate: string;
  updateDate: string;
  approvalDate: string | null;
  tags: number[];
  items: Item[];
  footer: Item;
  links: Link[];
  feedback: FeedbackEnum;
};

export type Item = {
  id: string;
  heading: string;
  itemType: string;
  items: Item[];
  contents: Content[];
  icon: IconEnum;
};

export type Content = {
  id: string;
  type: string;
  url: string | null;
  html: string | null;
  heading?: string | null;
};

export type Link = {
  id: string;
  type: string;
  url: string;
};
export type imageHashedState = {
  [hash: string]: string;
};

export type TroubleshootTagCategory = {
  id: number;
  name: string;
  tags: TroubleshootTag[];
};

export type TroubleshootTag = {
  id: number;
  name: string;
};

export enum GuideType {
  TROUBLESHOOT = 'Troubleshoot',
  INSTALLATIONS_AND_FUNCTIONS = 'InstallationsAndFunctions',
  PROJECTPLANNING_AND_DIMENSIONING = 'ProjectPlanningAndDimensioning'
}

export enum IconEnum {
  Troubleshoot = 'Troubleshoot',
  InstallationsAndFunctions = 'InstallationsAndFunctions',
  ProjectPlanningAndDimensioning = 'ProjectPlanningAndDimensioning',
  Alarm = 'Alarm',
  InverterCode = 'InverterCode'
}

export enum FeedbackEnum {
  None = 'None',
  Positive = 'Positive',
  Negative = 'Negative'
}

export type TroubleshootTagData = TroubleshootTagCategory[];
